import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import api from '../../services/api.service'

const BASE_PATH = '/lottustech/configuracoesPixAutomatico'
const crud = build(validate, BASE_PATH)
const prefix = 'crudConfiguracaoPixAutomatico'

const newTypes = {
  RESET: `${prefix}reset`,
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  SET_LOADING_VALIDAR_CREDENCIAIS: `${prefix}setLoadingValidarCredenciais`,
  SET_VALIDACAO_CREDENCIAIS_RESPONSE: `${prefix}setValidacaoCredenciaisResponse`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.setLoadingValidarCredenciais = (loading) => {
  return {
    type: types.SET_LOADING_VALIDAR_CREDENCIAIS,
    payload: loading,
  }
}

actions.setValidacaoCredenciaisResponse = (response) => {
  return {
    type: types.SET_VALIDACAO_CREDENCIAIS_RESPONSE,
    payload: response,
  }
}

actions.validarCredenciais = (dados) => {
  return (dispatch) => {
    dispatch(actions.setLoadingValidarCredenciais(true))
    return api
      .post(`${BASE_PATH}/validarCredenciais`, dados)
      .then((response) => {
        dispatch(actions.setLoadingValidarCredenciais(false))
        dispatch(actions.setValidacaoCredenciaisResponse({ success: true, message: 'Credenciais validadas com sucesso!', data: response.data }))
        return response
      })
      .catch((error) => {
        dispatch(actions.setLoadingValidarCredenciais(false))
        const errorData = error.response?.data || {}
        const errorMessage = errorData.mensagem || errorData.error || 'Erro ao validar credenciais'
        
        let responseBodyParsed = null
        if (errorData.responseBody) {
          try {
            responseBodyParsed = JSON.parse(errorData.responseBody)
          } catch (e) {
            responseBodyParsed = errorData.responseBody
          }
        }
        
        dispatch(actions.setValidacaoCredenciaisResponse({ 
          success: false, 
          message: errorMessage,
          responseBody: responseBodyParsed,
          statusCode: errorData.statusCode,
          psp: errorData.psp
        }))
        throw error
      })
  }
}

export { types, actions }
